import { gql } from '@apollo/client';

// ── Key Financial Drivers ──────────────────────────────────────────

export const GET_ALL_DRIVERS = gql`
  query GetAllDrivers($dealOpportunityId: ID!) {
    allDrivers(dealOpportunityId: $dealOpportunityId) {
      id
      title
      subtitle
      details
      driverType
    }
  }
`;

export const GET_ALL_SCENARIOS = gql`
  query GetAllScenarios($dealOpportunityId: ID!) {
    allScenarios(dealOpportunityId: $dealOpportunityId) {
      id
      title
      driverType
      probabilityLevel
      description
      impactText
      impactRevenueMin
      impactRevenueMax
      impactType
      impact
    }
  }
`;

export const UPSERT_DEAL_DRIVER = gql`
  mutation UpsertDealDriver(
    $dealOpportunityId: ID!
    $changesetArray: [DealDriverChangesetItemInput]
    $newRows: [DealDriverNewRowInput]
  ) {
    upsertDealDriver(
      dealOpportunityId: $dealOpportunityId
      changesetArray: $changesetArray
      newRows: $newRows
    ) {
      ok
      errors
      drivers {
        id
        title
        subtitle
        driverType
      }
    }
  }
`;

export const DELETE_DEAL_DRIVER = gql`
  mutation DeleteDealDriver($id: ID!) {
    deleteDealDriver(id: $id) {
      ok
      errors
    }
  }
`;

export const UPSERT_DEAL_SCENARIO = gql`
  mutation UpsertDealDriverProbableScenario(
    $dealOpportunityId: ID!
    $changesetArray: [DealDriverScenarioChangesetItemInput]
    $newRows: [DealDriverScenarioNewRowInput]
  ) {
    upsertDriverProbableScenario(
      dealOpportunityId: $dealOpportunityId
      changesetArray: $changesetArray
      newRows: $newRows
    ) {
      ok
      errors
      scenarios {
        id
        title
        driverType
        probabilityLevel
        description
        impactText
        impactRevenueMin
        impactRevenueMax
        impactType
        impact
      }
    }
  }
`;

export const DELETE_DEAL_SCENARIO = gql`
  mutation DeleteDealDriverProbableScenario($id: ID!) {
    deleteDriverProbableScenario(id: $id) {
      ok
      errors
    }
  }
`;

// ── Case Summary ──────────────────────────────────────────────────

export const GET_CASE_SUMMARY = gql`
  query GetCaseSummary($dealOpportunityId: ID!) {
    caseSummaryByDeal(dealOpportunityId: $dealOpportunityId) {
      id
      casesImage
      caseDescriptions {
        id
        name
        description
        borderColor
        sequence
      }
    }
  }
`;

export const UPSERT_CASE_SUMMARY = gql`
  mutation UpsertCaseSummary(
    $dealOpportunityId: ID!
    $values: DealCaseSummaryInput!
  ) {
    upsertCaseSummary(
      dealOpportunityId: $dealOpportunityId
      values: $values
    ) {
      ok
      errors
      caseSummary {
        id
        casesImage
        caseDescriptions {
          id
          name
          description
          borderColor
          sequence
        }
      }
    }
  }
`;

// ── Financial Cases ───────────────────────────────────────────────

export const GET_FINANCIAL_CASES = gql`
  query GetFinancialCases($dealOpportunityId: ID!) {
    financialCasesByDeal(dealOpportunityId: $dealOpportunityId) {
      id
      image
      commentary
      caseType
    }
  }
`;

export const UPSERT_FINANCIAL_CASE = gql`
  mutation UpsertFinancialCase(
    $dealOpportunityId: ID!
    $caseType: String!
    $values: DealFinancialCaseInput!
  ) {
    upsertFinancialCase(
      dealOpportunityId: $dealOpportunityId
      caseType: $caseType
      values: $values
    ) {
      ok
      errors
      financialCase {
        id
        image
        commentary
        caseType
      }
    }
  }
`;

// ── Governance Overview ───────────────────────────────────────────

export const GET_GOVERNANCE_OVERVIEW = gql`
  query GetGovernanceOverview($dealOpportunityId: ID!) {
    governanceOverviewByDeal(dealOpportunityId: $dealOpportunityId) {
      id
      ownershipPctImage
      managementImage
      boardOfDirectorsStructure
    }
  }
`;

export const UPSERT_GOVERNANCE_OVERVIEW = gql`
  mutation UpsertGovernanceOverview($values: DealGovernanceOverviewInput!) {
    upsertGovernanceOverview(values: $values) {
      ok
      errors
      governanceOverview {
        id
        ownershipPctImage
        managementImage
        boardOfDirectorsStructure
      }
    }
  }
`;


